import { useJsApiLoader } from '@react-google-maps/api';

// Define libraries as a constant OUTSIDE the component to prevent recreation
const GOOGLE_MAPS_LIBRARIES  = ["places", "marker", "maps"];

export const useGoogleMaps = () => {
  return useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    version: "beta",
    id: "script-loader",
    libraries: GOOGLE_MAPS_LIBRARIES, // Use the constant reference
    language: "en",
    region: "US"
  });
};